import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../pages/laudo/etapas/material/material.action';
import RastreabilidadePage from './rastreabilidade.page';
import { acessoPermitido } from '../../../acessos.seguranca';

class RastreabilidadeContainer extends Component {
  render() {
    return (
      <RastreabilidadePage
        usuario={this.props.usuario}
        listagemRastreabilidade={this.props.listagemRastreabilidade}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    modalRecolhimento: state.recebimentoMaterial.modalRecolhimento,
    listagemRastreabilidade: state.commonReducer.listagemRastreabilidade,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RastreabilidadeContainer);



// WEBPACK FOOTER //
// ./src/app/common/rastreabilidade/rastreabilidade.container.js